import { iaRa } from 'lib/helpers/utility';

import { formatMultipleMedsFormat, formatMultipleWhlFormat } from '../lib/helpers';
import { translateMedicationToWeightLossData } from '../../Provider/WeightLoss/lib/helpers';

export const handleStatusFormatData = (data) => {
  const syncedMedsToWhl = iaRa(data).filter((med) => med?.weight_loss_medication_id);

  const weightLossResponses = iaRa(syncedMedsToWhl).map((med) =>
    translateMedicationToWeightLossData({
      medication: med,
      medication_id: med?.id,
      weight: med?.weight,
      showId: true
    })
  );
  const medData = {
    medications: formatMultipleMedsFormat(data, data[0]?.status)
  };
  const whlData = formatMultipleWhlFormat(weightLossResponses, data[0]?.status);
  return { whlData, medData };
};

export const findStatusLabelAndColor = ({ type = 'label', data }) => {
  if (type == 'label') return data[0]?.status === 'active' ? 'Inactive' : 'Active';
  return data[0]?.status === 'active' ? 'danger' : 'primary';
};

export const handleIsPatientCase = ({ values, patientIdProp, practiceId, formik }) => {
  if (patientIdProp) {
    practiceId = values?.practice_id;
    delete values?.practice_id;
    if (!practiceId) {
      formik.setFieldError('practice_id', 'Practice is required');
      return null;
    }
  } else {
    practiceId = values?.practice_id;
  }
  return practiceId;
};
